<template xmlns="http://www.w3.org/1999/html">
  <div class="login">
    <div class="center_box t-10">
      <div class="login_tit tl">
        登录成功！</br>
        请完善您的资料以继续
      </div>
      <div class="login_min">
        <vue-form :state="formstate" id="loginForm">
          <validate tag="div" class="p_rel">
            <p>姓名</p>
            <input class="pass_word" id="user_name" type="text" name="username" v-model="params.name"
                   placeholder="" required >
            <field-messages name="username" show="$dirty || $touched || $submitted">
              <div slot="required" class="errorMessage">姓名不能为空</div>
            </field-messages>
          </validate>
          <validate tag="div" class="p_rel">
            <p>居民身份证</p>
            <input id="password" class="pass_word" type="text" name="idCard" v-model="params.id_card" placeholder=""
                   required pattern="(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)">
            <field-messages name="idCard" show="$dirty || $touched || $submitted">
              <div slot="required" class="errorMessage">身份证号不能为空</div>
              <div slot="pattern" class="errorMessage">请填写正确的身份证号</div>
            </field-messages>
          </validate>
          <div>
            <button id="login" :class="{can_login:disabled==true}" @click.prevent="gotoNext" type="" :disabled="!disabled">下一步</button>
          </div>
          <p style="margin-top: 15px">以上信息不容许修改，请确认填写无误</p>
        </vue-form>
      </div>
    </div>
    <toastTips :content="toastContent" :is-show="toast"></toastTips>
  </div>
</template>
<script>
  import axios from 'axios'
  import qs from 'qs'
  import toastTips from '../../components/layer/toastTips'
export default {
  name: 'improveStep1',
  components:{
    toastTips
  },
  data () {
     return {
      params:{
        name:'',
        id_card:''
      },
      disabled:false,
      errorMsg:'',
      mobile:'',
       formstate:{},
       toast:false,
       toastContent:''
    }
  },
  methods:{
    gotoNext:function(){
      var that=this;
      axios.post('/admin/updateBase',qs.stringify(

          that.params

      )).then((response)=>{
        var that=this;
        console.log(response);
        if(response.data.code == 22000){
          that.mobile=response.data.result.mobile;
          that.$emit('nextStep',{step:2,mobile:response.data.result.mobile})
        }else{
          that.toast=true;
          that.toastContent=response.data.message;
          setTimeout(function(){
            that.toast=false;
            that.toastContent='';
          },3000)
        }
      })

    }
  },
  watch:{
    'formstate.$invalid':function(){
      if(!this.formstate.$invalid){
        this.disabled=true;
      }else{
        this.disabled=false;
      }

    }
  }
}
</script>
<style lang="less" scoped>
.login_min{
  margin-top: 40px;
  div{
    margin-top: 10px;
    p{
      line-height: 40px;
      font-size: 16px;
    }
  }
}
.t80{
  top:80px!important;
}
.t-10{
  top: 10%!important;
  margin-top: 0!important;
}
.p_rel{
  position: relative !important;
}
</style>



// WEBPACK FOOTER //
// src/components/improve_info/step1.vue